import type { CustomerStatus } from "@/mocks/admin/customers";

const styles: Record<CustomerStatus, { label: string; cls: string; dot: string }> = {
  active: { label: "Active", cls: "bg-emerald-50 text-emerald-700", dot: "bg-emerald-500" },
  vip: { label: "VIP", cls: "bg-amber-50 text-amber-700", dot: "bg-amber-500" },
  lead: { label: "Lead", cls: "bg-indigo-50 text-indigo-700", dot: "bg-indigo-500" },
  dormant: { label: "Dormant", cls: "bg-cream-100 text-ink-500", dot: "bg-ink-300" },
};

export default function StatusBadge({ status }: { status: CustomerStatus }) {
  const s = styles[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-semibold ${s.cls}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`}></span>
      {s.label}
    </span>
  );
}